module.exports = __webpack_public_path__ + "static/media/promotion.7755cf1e.svg";